import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = never;

function mapResponse(_: ApiResponse) {
  return true;
}

const endpoint = new FetchEndpoint({
  urlFactory: () => '/nonprofit-salary-explorer/survey',
  mapResponse,
});

// Exports

/**
 * When user cannot submit survey this endpoint throws an error
 */
export const salariesApiIsomorphicFetchCanSubmitSurvey =
  endpoint.createIsomorphicFetchFn();
